import { ONBOARDING_API_ENDPOINT } from "../config/url.config";

export const getOnboardingToken = () => {
  if (typeof window === "undefined") return null;
  try {
    return localStorage.getItem("onboardingToken");
  } catch (error) {
    return null;
  }
};

export const getAuthHeader = () => {
  const token = getOnboardingToken();
  return token ? { Authorization: "Bearer " + token } : {};
};

async function SuperFetch (endpoint, method, data, token) {
  const resolvedToken = token || getOnboardingToken();
  const response = await fetch(`${ONBOARDING_API_ENDPOINT}${endpoint}`, {
      method,
      headers: resolvedToken ? { Authorization: "Bearer " + resolvedToken } : {},
      body: method === "get" ? undefined : JSON.stringify(data),
  });

  const res = await response.json();

  return res
}

export default SuperFetch ;